import {
  RangeTenantConfiguration,
  RangeTranslations,
} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

enum RangeUnits {
  km = 'resultKM',
  miles = 'resultMiles',
}

export const getFormattedRangeResult = (
  tenantConfiguration: RangeTenantConfiguration,
  translations: RangeTranslations,
  rangeKm: number
): string => {
  const convertRangeFromKm = (rangeKm: number, unit: RangeUnits): number => {
    switch (unit) {
      case RangeUnits.km:
        return rangeKm;
      case RangeUnits.miles:
        return rangeKm / 1.609344;
    }
  };

  function getRangeUnit(): RangeUnits {
    const unit = tenantConfiguration.global.rangeUnit;
    switch (unit) {
      case 'km':
        return RangeUnits.km;
      case 'miles':
        return RangeUnits.miles;
    }
  }

  function getRangeValueText(unit: RangeUnits, convertedRange: number) {
    return translations.resultSection[unit].replace(
      '%%range%%',
      Math.round(convertedRange).toString()
    );
  }

  const rangeUnit = getRangeUnit();
  const convertedRange = convertRangeFromKm(rangeKm, rangeUnit);
  return getRangeValueText(rangeUnit, convertedRange);
};
